export default "__VITE_ASSET__CscsSxyH__"